import "./index.less";
import * as React from "react";
import { AtButton, IAtButtonProps } from "@atman/design-system";
import { CustomTextInput } from "../CustomTextInput";

export interface IAtListHeaderProps {
    customLeftHeaderContent?: React.ReactNode;
    searchString?: string;
    searchStringFieldName?: string;
    searchInputPlaceholder?: string;
    onSearchStringChange?: (e: React.FormEvent<HTMLInputElement>) => void;
    buttons?: IAtButtonProps[];
}

export const AtListHeader: React.FC<IAtListHeaderProps> = (props) => {
    const {
        customLeftHeaderContent,
        searchString,
        searchStringFieldName,
        onSearchStringChange,
        buttons,
        searchInputPlaceholder,
    } = props;

    return (
        <div className="AtListHeader">
            <div className="left-container">
                {customLeftHeaderContent ? (
                    customLeftHeaderContent
                ) : (
                    <CustomTextInput
                        leftIcon={["far", "search"]}
                        className={"list-header-search-input"}
                        fieldName={searchStringFieldName ?? "searchString"}
                        value={searchString}
                        onChange={onSearchStringChange ?? (() => null)}
                        placeholder={searchInputPlaceholder ?? "global.search".localize()}
                        hideLabel
                    />
                )}
            </div>
            <div className="right-container">
                {buttons?.map((x, i) => (
                    <AtButton {...x} key={`at-list-btn-${i}`} />
                ))}
            </div>
        </div>
    );
};
